export default __webpack_public_path__ + "static/media/tokenomicsElementRight.468e790d.png";